import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface ProblemPropertyIndicatorParameters {
    problemProperty: boolean;
    onChange: (checked: boolean) => void;
}

export const ProblemPropertyIndicator: React.FC<ProblemPropertyIndicatorParameters> = ({ problemProperty, onChange }) => {
    return (
        <>
            <div className='columns small-12 medium-3'>
                <label style={{ display: 'flex' }}>
                    <input
                        type='checkbox'
                        checked={problemProperty}
                        onChange={(e) => onChange(e.target.checked)}
                        title='Is this property a problem?'
                        style={{ paddingTop: '5px' }}
                    />
                    <div style={{ paddingTop: '2px' }}>Problem Property?</div>
                    <span
                        className='helper'
                        style={{ position: 'relative', display: 'inline-block', paddingBottom: '2px', paddingLeft: '25px' }}
                    >
                        <span className='tooltip-trigger'>
                            <FontAwesomeIcon icon={faQuestionCircle} />
                        </span>
                        <span className='text'>
                            Checking this box will add this notice to Draw Emails for this Property:
                            <br />
                            <br />
                            'Please check with senior management before funding this draw.'
                        </span>
                    </span>
                </label>
            </div>
        </>
    );
};
